class Cinema {
  constructor({
    MovieProviderID,
    Name,
    Logo,
    MobileNumber,
    LocationName,
    Latitude,
    Longitude,
    Rating,
    RestaurantID,
    Distance,
    RideCost,
  }) {
    this.MovieProviderID = MovieProviderID;
    this.Name = Name;
    this.Logo = Logo;
    this.MobileNumber = MobileNumber;
    this.LocationName = LocationName;
    this.Latitude = Latitude;
    this.Longitude = Longitude;
    this.Rating = Rating;
    this.RestaurantID = RestaurantID;
    this.Distance = Distance;
    this.RideCost = RideCost;
  }
}
export default Cinema;
